export default __webpack_public_path__ + "locales/pt-BR/ChangePasswordDialog.json?hash=21f6becaf274dee16c4b209bb8e65fca";